import { useContext } from 'react';

import { TopBannersHeightContext } from '../context';

export const useTopBannersHeight = () => useContext(TopBannersHeightContext);
